var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 16.5L10.9987 13.7042L14.6654 16.5L13.2904 11.9625L16.957 9.35001H12.4654L10.9987 4.58334L9.53203 9.35001H5.04036L8.70703 11.9625L7.33203 16.5ZM10.9987 20.1667C9.73064 20.1667 8.53898 19.9261 7.4237 19.4448C6.30842 18.9636 5.33828 18.3104 4.51328 17.4854C3.68828 16.6604 3.03516 15.6903 2.55391 14.575C2.07266 13.4597 1.83203 12.2681 1.83203 11C1.83203 9.73195 2.07266 8.54029 2.55391 7.42501C3.03516 6.30973 3.68828 5.33959 4.51328 4.51459C5.33828 3.68959 6.30842 3.03647 7.4237 2.55522C8.53898 2.07397 9.73064 1.83334 10.9987 1.83334C12.2668 1.83334 13.4584 2.07397 14.5737 2.55522C15.689 3.03647 16.6591 3.68959 17.4841 4.51459C18.3091 5.33959 18.9622 6.30973 19.4435 7.42501C19.9247 8.54029 20.1654 9.73195 20.1654 11C20.1654 12.2681 19.9247 13.4597 19.4435 14.575C18.9622 15.6903 18.3091 16.6604 17.4841 17.4854C16.6591 18.3104 15.689 18.9636 14.5737 19.4448C13.4584 19.9261 12.2668 20.1667 10.9987 20.1667Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliver);
export default __webpack_public_path__ + "static/media/sliver.773206bd261933938ead143c07b3816a.svg";
export { ForwardRef as ReactComponent };